/* eslint-disable no-irregular-whitespace */
export default {
  title: "智慧康用户服务协议",
  content: `<b><p>欢迎访问智慧康网站并使用我们提供的产品和服务。</p>
    	<p></p>
    	<p>在完成注册程序或以任何方式使用智慧康网站服务前，请您务必仔细阅读并透彻理解本智慧康网站服务条款(以下或简称“服务条款”)，在确认充分理解后选择接受或不接受本服务条款；一旦您完成“同意条款并注册”或开始以其他方式使用智慧康服务，即表明您已阅读并同意受本服务条款的约束。如您不同意本服务条款或其中任何条款约定，您应不再进行下一步或停止注册程序。</p>
    	<p></p>
    	<p>智慧康再次提示您审慎阅读、充分理解各条款内容，特别是限制或免除责任的相应条款，限制或免除责任条款可能会以加粗或其他醒目形式提示您注意。</p>
    	<p></p>
    	<p>如果您未满18周岁，请在法定监护人的陪同下阅读本服务条款及相关条款，特别是未成年人注册及用户信息的特别约定；您注册智慧康账户和/或购买、使用智慧康提供的服务前应当获得法定监护人的同意。</p>
    	<p></p>
    	<h2>一、签约主体以及协议范围</h2>
    	<p></p>
    	<p>1.1.智慧康网站服务条款是您与海口智慧康网络科技有限公司（“智慧康”或者“我们”）就使用智慧康网站服务（包含为您提供网站页面信息浏览、账户注册服务等，以下称“本服务”）而订立的有效合约。</p>
    	<p>1.2.如您使用或购买智慧康网站上某一具体产品和/或服务，您可仍需确认具服务对应的服务条款；请您审慎阅读、充分理解各条款内容，选择接受或不接受该服务条款。</p></b>
    	<p></p>
    	<p></p>
    	<h2>二、账户的注册、使用与安全</h2>
    	<p></p>
    	<p>2.1.注册的资格</p>
    	<p></p>
    	<p>2.1.1.您确认，在您完成注册程序或以其他智慧康允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织（以下或简称为“您”）。</p>
    	<p>2.1.2.若您是未成年人或限制民事行为能力人，则您不具备前述主体资格，您及您的监护人应承担因您的不当注册行为而导致的一切后果。</p>
    	<p>2.1.3.您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用智慧康服务。</p>
    	<p></p>
    	<p>2.2.账户注册</p>
    	<p></p>
    	<p>2.2.1.当您按照注册页面提示填写信息、阅读并同意本服务条款且完成全部注册程序后，您可获得智慧康账户并成为智慧康的用户。</p>
    	<p>2.2.2.您可以通过设置或确认的账户名（“账户名称”）及您设置的密码完成注册程序；您可选择通过设置登陆手机号码并完成动态验证、授权使用第三方账户关联注册或智慧康提供的其他注册方式，完成智慧康用户账户的注册。在您通过某一形式注册账户时，智慧康可能会为您自动生成一个“账号ID”。您理解并同意，当提及您的智慧康账户或者账号时，实际是指上述账户名称与密码、登陆手机号、被授权的第三方账户或在用户界面内归属在“账户”或“账号”下的其他信息的统称。</p>
    	<p>2.2.3.您设置的账户名不得违反国家法律法规、公序良俗、社会公德、智慧康的管理规范或容易引起您与智慧康身份的混淆，否则您的账户可能不能注册成功或智慧康有权经通知您后予以注销。</p>
    	<p>2.2.4.您应当按照法律法规要求或按相应页面的提示，准确提供并及时更新您的账户信息，以使之真实、及时、完整和准确。如您提供的资料错误、不实、过时或不完整的，智慧康可以向您发出询问及/或要求改正的通知，您应按照智慧康的要求配合提供或者更新相关资料。因您填写的信息、资料不真实、不及时、不完整或不准确的，您应承担您不能使用智慧康账户（不能注册成功、或账户被冻结、注销）或您在使用过程中的后果和损失。</p>
    	<p>2.2.5.智慧康可能会就某些服务的开通，要求您提供更多的身份资料和信息，做进一步的身份认证或资格验证，您的账户只有在通过这些认证和验证之后，方可获得使用相关服务的资格。</p>
    	<p>2.2.6.通常情况下，您的智慧康账户是您在智慧康网站进行一切活动的唯一身份标识，除非另有约定，每一个智慧康账户都可以在本网站独立开展活动。但在下列情形下，智慧康有权根据自己的判断，对同一及/或关联法律主体拥有的多个智慧康账户进行统一处理，如根据不同智慧康账户在注册、登录、使用中的关联信息，智慧康判断其实际为同一用户。关联信息举例：同一证件、同一手机号、同一支付账户、同一设备、同一地址等。</p>
    	<p></p>
    	<p>2.3.账户的使用和安全</p>
    	<p></p>
    	<p>2.3.1.注册的资格</p>
    	<p>2.3.1.1.您确认，在您完成注册程序或以其他智慧康允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织（以下或简称为“您”）。</p>
    	<p>2.3.1.2.若您是未成年人或限制民事行为能力人，则您不具备前述主体资格，您及您的监护人应承担因您的不当注册行为而导致的一切后果。</p>
    	<p>2.3.1.3.您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用智慧康服务。</p>
    	<p></p>
    	<p>2.3.2.账户注册</p>
    	<p>2.3.2.1.当您按照注册页面提示填写信息、阅读并同意本服务条款且完成全部注册程序后，您可获得智慧康账户并成为智慧康的用户。</p>
    	<p>2.3.2.2.您在注册时候设置或确认的账户名（“账户名称”）及您设置的密码，将在注册成功后成为您的账户（账户名称及密码合称“账户”）。</p>
    	<p>2.3.2.3.您设置的账户名不得违反国家法律法规、智慧康的管理规范或容易引起您与智慧康身份的混淆，否则您的账户可能不能注册成功或智慧康有权经通知您后予以注销。</p>
    	<p>2.3.2.4.您应当按照法律法规要求或按相应页面的提示，准确提供并及时更新您的账户信息，以使之真实、及时、完整和准确。如您提供的资料错误、不实、过时或不完整的，智慧康可以向您发出询问及/或要求改正的通知，您应按照智慧康的要求配合提供或者更新相关资料。因您填写的信息、资料不真实、不及时、不完整或不准确的，您应承担您不能使用智慧康账户（不能注册成功、或账户被冻结、注销）或您在使用过程中的后果和损失。</p>
    	<p>2.3.2.5.智慧康可能会就某些产品或服务的开通，要求您提供更多的身份资料和信息，做进一步的身份认证或资格验证，您的账户只有在通过这些认证和验证之后，方可获得使用相关产品或服务的资格。</p>
    	<p>2.3.2.6.通常情况下，您的智慧康账户是您在智慧康网站进行一切活动的唯一身份标识，除非另有约定，每一个智慧康账户都可以在本网站独立开展活动。但在下列情形下，智慧康有权根据自己的判断，对同一及/或关联法律主体拥有的多个智慧康账户进行统一处理，如根据不同智慧康账户在注册、登录、使用中的关联信息，智慧康判断其实际为同一用户。关联信息举例：同一证件、同一手机号、同一支付账号、同一设备、同一地址等。</p>
    	<p></p>
    	<p>2.3.3.账户的使用和安全</p>
    	<p>2.3.3.1.您有权使用您设定的账户登录智慧康网站，进而使用智慧康提供的其他服务。</p>
    	<p>2.3.3.2.智慧康可能会以邮件、站内信、短信或电话等方式通知您服务进展情况以及提示您进行下一步的操作。在服务过程中您应当及时登录到智慧康账户查看和进行交易操作。</p>
    	<p>2.3.3.3.一个智慧康账户仅能对应唯一的法律主体。除非有法律明文规定、司法裁定或者经智慧康同意的情况下，您不得以任何方式转让、赠与或让他人继承您的智慧康账户。</p>
    	<p>2.3.3.4.您的账户和密码由您自行设置并由您保管，您须对您的智慧康账户和密码保密。您需确保您在每个上网时段结束时，以正确步骤离开网站。</p>
    	<p>2.3.3.5.如发现他人未经授权使用您的智慧康账户和密码，您应立即通知智慧康；智慧康将协助您冻结账户、更改密码或进行其他安全设置；您理解智慧康对您的请求采取行动需要合理时间，智慧康对在采取行动前已经产生的以及由您引发的后果（包括但不限于您的任何损失）不承担任何责任。</p>
    	<p>2.3.3.6.智慧康亦会在网站服务端采取合理的技术措施保障账户的安全。</p>
    	<p>2.3.3.7.任何主体不得以任何方式恶意进行批量注册智慧康账号，实施刷靓号等违反行为，一旦发现有上述行为者，智慧康有权直接冻结、禁用相关账号以及注销账号。</p>
    	<p></p>
    	<p></p>
    	<h2>三、账户的冻结、注销及申诉</h2>
    	<p></p>
    	<p>3.1.账户的冻结</p>
    	<p></p>
    	<p>您的智慧康账户（全部或部分权限或功能）在如下情况可能被冻结（例如，智慧康账户被限制登陆；被限制资金转出功能等），智慧康将通过邮件、站内信、短信或电话等方式通知您：</p>
    	<p>3.1.1.基于智慧康网站或服务运行和交易安全的需要，如您发生或可能发生破坏或试图破坏智慧康或智慧康关联公司公平交易环境或正常交易秩序的，或任何使用含有智慧康或智慧康关联公司名称、品牌且对他人有误导嫌疑或任何使用某种中英文(全称或简称)、数字、域名等意图表示或映射与智慧康或其关联公司具有某种关联的；</p>
    	<p>3.1.2.违反本服务条款、智慧康网站的相关规则、规范（如平台安全规则、交易规则、管理规范等）、服务说明以及其他服务协议/条款的；</p>
    	<p>3.1.3.违反国家法律、法规、政策、法律文书的规定的；</p>
    	<p>3.1.4.您遭到他人投诉，且对方已经提供了相关证据的，而您未按照我们的要求提供相反证据的；</p>
    	<p>3.1.5.智慧康根据合理分析判断您的账户操作、收益、兑换等存在异常的；</p>
    	<p>3.1.6.国家有权机关要求进行的冻结的；</p>
    	<p>3.1.7.智慧康合理判断，同一用户发生与如上行为性质相同或产生如上类似风险的其他情况的。</p>
    	<p></p>
    	<p>3.2.账户的注销</p>
    	<p></p>
    	<p>3.2.1.出现以下情形之一的，您的智慧康账号将被注销：</p>
    	<p>3.2.1.1. 智慧康依据您本人提交的账号注销申请，依照法律的规定和账户注销流程，处理您提交的注销请求并完成账号注销的。</p>
    	<p>3.2.1.2.当出现如上第3.1条情形且情形严重的，或基于国家有权机关的要求，智慧康对您的相关智慧康账户进行注销，智慧康将通过邮件、短信、电话或其他适宜的方式通知您。</p>
    	<p>3.2.1.3.当您连续12个月未通过账户登录过智慧康网站（含账户冻结期间），且您的账户下不存在任何未到期的服务，智慧康有权（但无义务）注销您的账户。</p>
    	<p></p>
    	<p>3.2.2.您理解并同意，账户一经注销，您将：</p>
    	<p>3.2.2.1无法再次登录智慧康网站；</p>
    	<p>3.2.2.2无法访问控制面板或站点控制面板；</p>
    	<p>3.2.2.3无法进行依赖于账户权限进行的其他操作；</p>
    	<p>3.2.2.4无法找回该账户下的个人信息、交易记录、业务数据、历史信息等。</p>
    	<p>3.2.2.5但账户注销并不代表您在该账户注销前的所有账户行为和相关责任得到豁免或减轻。</p>
    	<p></p>
    	<p>3.2.3账户注销后，智慧康将：</p>
    	<p>3.2.3.1无权继续收集、存储和使用您的个人信息和数据，但法律法规另有要求的情形除外，例如：为了税务合规而保留相应的发票信息等；</p>
    	<p>3.2.3.2有义务在遵守国家法律法规的前提下，保障您在该账户下的所有数据在实现日常业务功能所涉及的系统中不可被检索、访问；</p>
    	<p>3.2.3.3账户注销不影响智慧康在监管机关要求或其他合法场景下，依法确认该账户注销前的用户真实身份等相关义务的履行。</p>
    	<p></p>
    	<p>3.3.申诉</p>
    	<p></p>
    	<p>发生前述账户冻结或注销情况下，您应及时予以关注并可以按照程序进行申诉等后续操作：</p>
    	<p></p>
    	<p>3.3.1.您通过申诉程序，向智慧康申请解除上述冻结或注销的，为了您的账户安全，您应配合如实提供身份证明及相关资料，以及智慧康要求的其他信息或文件，以便智慧康进行核实。您应充分理解您的申诉并不必然被允许，智慧康有权决定是否同意您的申诉请求。</p>
    	<p>3.3.2.您理解并同意，如果您拒绝如实提供身份证明及相关资料，或未能通过智慧康审核，智慧康有权长期冻结该等账户且长期限制账户部分或全部功能，直至前述情形被得以合理纠正，或基于第3.2.1.3条的约定注销该账户。</p>
    	<p></p>
    	<p>3.4您理解并同意，您名下如存在多个智慧康账户，因您的违法、违规、违约行为导致其中一个或多个账户被冻结或注销的，智慧康有权根据具体情形及相关风险程度作合理判断，对您的其他全部或部分账户予以冻结或注销。</p>
    	<p></p>
    	<p></p>
    	<h2>四、网站服务及规范</h2>
    	<p></p>
    	<p>4.1.您有权享受智慧康通过本网站提供的互联网技术服务和信息服务。您同时还应根据本服务条款时确认的相关条款和条件，履行及时付款、服务管理等责任。</p>
    	<p>4.2.您使用智慧康服务时，您应保证：</p>
    	<p>4.2.1.您使用智慧康服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用智慧康提供的服务进行存储、发布、传播如下信息和内容：</p>
    	<p>（ⅰ）违反国家法律法规政策的任何内容（信息）；</p>
    	<p>（ⅱ）违反国家规定的政治宣传和/或新闻信息；</p>
    	<p>（ⅲ）涉及国家秘密和/或安全的信息；</p>
    	<p>（ⅳ）封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；</p>
    	<p>（ⅴ）博彩有奖、赌博游戏；违反国家民族和宗教政策的信息；</p>
    	<p>（ⅵ）妨碍互联网运行安全的信息；</p>
    	<p>（ⅶ）侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息或内容；</p>
    	<p>（ⅷ）您同时承诺不得为他人发布上述不符合国家规定和/或本服务条款约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接等；</p>
    	<p>4.2.2.不应出现任何破坏或试图破坏网络安全等的行为，包括不会利用技术或其他手段破坏或扰乱本网站及智慧康其他客户的网站；</p>
    	<p>4.2.3.您使用智慧康网站的服务应符合本服务条款；</p>
    	<p></p>
    	<p>如您违反上述保证，智慧康除有权根据相关服务条款采取删除信息、中止服务、终止服务的措施，并有权冻结或注销您账户部分或全部功能。</p>
    	<p></p>
    	<h2>五、隐私及个人信息的保护</h2>
    	<p></p>
    	<p>您的信任对智慧康非常重要，智慧康深知用户信息安全的重要性，智慧康将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。具体详见《法律声明及隐私权政策》。</p>
    	<p></p>
    	<h2>六、知识产权</h2>
    	<p></p>
    	<p>6.1.我们尊重知识产权，除非获得了您的同意，智慧康不会擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表您拥有知识产权的成果。</p>
    	<p>6.2.任何组织或个人认为智慧康网站的网页内容，如转载文章等可能侵犯其合法权益的，可向智慧康（https://www.hkzhihuikang.com）提出书面权利通知，智慧康将在收到知识产权权利人合格通知后依法尽快处理。</p>
    	<p>6.3.除非另行说明，智慧康网站Logo、“智慧康”等文字、图形及其组合，以及智慧康网站的其他标识、徽记、智慧康服务的名称、技术文档等的知识产权为智慧康及其关联公司所有。“知识产权”包括在专利法、著作权法、商标法、反不正当竞争法等法律中规定的任何和所有权利、所有权和利益，以及其中的任何和所有应用、更新、扩展和恢复。</p>
    	<p>6.4.您不得攻击智慧康官网，不得修改、改编、翻译的软件、技术、材料等，不得通过反向工程、反编译、反汇编或其他类似行为获得的源代码，否则由此引起的一切法律后果由您负责，智慧康有权依法追究您的法律责任。</p>
    	<p>6.5.您应尊重智慧康和第三方的知识产权和其他合法权利/权益，并保证在发生侵犯前述权益的违法事件时，保护智慧康及其雇员、股东、合作伙伴等免于因该等事件受到影响或损失，智慧康保留在您侵犯智慧康及/或其他第三方的合法权利/权益时终止向您提供服务并不退还任何款项的权利。</p>
    	<p></p>
    	<p></p>
    	<p>其他具体信息详见《法律声明及隐私权政策》的法律声明部分。</p>
    	<p></p>
    	<h2>七、保密</h2>
    	<p></p>
    	<p>智慧康承诺对您注册账户时或使用智慧康服务时提交或知悉的信息采取保密措施，不向第三方披露您的信息，除非</p>
    	<p>7.1.依据本服务条款或者您与智慧康之间其他服务协议、合同、在线条款等规定可以提供的；</p>
    	<p>7.2.依据法律法规的规定或行政、司法等职权部门要求应当提供的；</p>
    	<p>7.3.在不违反本服务条款约定责任的前提下，该保密信息已经公开或能从公开领域获得；</p>
    	<p>7.4.为提供您要求的服务所必需。</p>
    	<p></p>
    	<h2>八、出口管制</h2>
    	<p></p>
    	<p>双方承诺遵守本协议所适用的联合国、中国、美国以及其他国家出口管制法律法规。您承诺不会将智慧康提供的产品或服务用于适用的出口管制法律法规禁止的用途。非经相关主管机关许可，您及您授权使用智慧康产品或服务的其他个人或实体不会通过智慧康产品或服务向适用的出口管制法律法规禁止的实体或个人提供受管控的技术、软件或服务。</p>
    	<p></p>
    	<p></p>
    	<h2>九、信息安全事件</h2>
    	<p></p>
    	<p>智慧康将采取符合业界标准的安全技术措施保护您提供的个人信息安全，并依据国家法律法规的要求、遵照相关安全事件处理标准管理信息安全事件。当发生涉及您相关资产的信息安全事件时，我们会依法及时将事件相关的情况通过邮件、信函、电话、推送通知等方式告知，您也可通过工单、客服电话、大客户经理电话等方式主动联系我们。</p>
    	<p></p>
    	<p></p>
    	<h2>十、责任范围和责任限制</h2>
    	<p></p>
    	<p>10.1.您了解并同意，您应承担因您使用本服务、违反本服务条款或在您的账户下采取的任何行动而导致的任何第三方索赔。如果由此引起智慧康及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并赔偿智慧康及其关联公司由此遭受的全部损失和责任。</p>
    	<p>10.2.在适用法律许可的范围内，智慧康不对与本服务条款有关或由本服务条款引起的任何间接的、惩罚性的、特殊的、派生的损失承担赔偿责任。</p>
    	<p>10.3.智慧康在此提示，您在使用智慧康服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用智慧康的服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。智慧康不对您使用智慧康服务的违法或违约行为承担任何责任。</p>
    	<p>10.4.在某些情况下，为了帮助您更便捷的使用智慧康服务，智慧康可能会展示智慧康的参考代码或软件（如属于第三方开源软件，您则应遵守第三方开源软件的相关使用要求），基于相应展示页面的使用说明，该等软件可能允许您予以下载、进行二次开发等相关操作，您应理解并承诺，该等代码的知识产权属于智慧康，您在使用时应明确表明权利人，同时，智慧康不对您能否使用以及使用该等代码、软件的工作和后果负责。</p>
    	<p></p>
    	<p></p>
    	<h2>十一、不可抗力和意外事件</h2>
    	<p></p>
    	<p>智慧康的网站及服务是按照现有技术和条件所能达到的现状提供的，智慧康会尽最大努力保障服务的连贯性和安全性，但不能随时预见和防范法律、技术以及其他风险，在法律允许的范围内，如因下列不可抗力或意外事件无法正常提供服务的，智慧康不承担任何法律责任：</p>
    	<p></p>
    	<p>11.1.不可抗力，即双方所不能预见、并且它的发生及其后果是不能克服和不能避免的客观情况，包括但不限于如下情形：(1)自然灾害如洪水、冰雹、海啸、台风、旱灾、火灾；(2)社会因素如罢工、暴乱、战争及所适用的政策、法律、法规导致不能履行；</p>
    	<p>11.2.因电力供应故障、通讯网络故障等公共服务因素；</p>
    	<p>11.3.因黑客攻击、病毒、您自身软硬件设备异常等非智慧康独立责任；</p>
    	<p>11.4.经提前公告或通知的，智慧康在短时间内的系统维护（包括但不限于排除故障、系统升级、系统扩容、服务器迁移）。</p>
    	<p></p>
    	<p></p>
    	<h2>十二、法律适用与管辖</h2>
    	<p></p>
    	<p>本服务条款之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本服务条款产生之争议应提交至浙江省杭州市西湖区人民法院解决。</p>
    	<p></p>
    	<p></p>
    	<h2>十三、通知送达</h2>
    	<p></p>
    	<p>13.1.您理解并同意，智慧康可通过网页公告、电子邮件、站内信、短信、电话、系统消息以及即时通信等以上一种或多种通知方式向您发送通知，且智慧康可以信赖您所提供的联系信息是完整、准确且当前有效的；上述通知在发送成功后视为已送达。</p>
    	<p>13.2．除非本服务条款另有约定或智慧康与您另行签订的协议明确规定了通知方式，您发送给智慧康的通知，应当通过智慧康对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
    	<p></p>
    	<p></p>
    	<h2>十四、条款的更新和终止</h2>
    	<p></p>
    	<p>14.1.智慧康有权对本服务条款及相应的服务规则内容进行变更，并将网页公告、电子邮件、站内信、短信等方式予以公告或通知；若您在本服务条款内容变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的条款内容。</p>
    	<p>14.2.在您的账户注销或经双方协商一致终止网站服务的，本服务条款终止。</p>
    	<p></p>
    	<p></p>
    	<h2>十五、其他</h2>
    	<p></p>
    	<p>15.1.本服务条款由本服务条款的内容、网站相关页面上展现的规则、规范，服务说明（含操作文档）和您点击确认的其他条款/条件组成，智慧康和您均受其约束，且其中的相关名词可相互引用、解释。</p>
    	<p>15.2.本服务条款的章节标题仅为行文方便而设，不具有法律或合同效力。</p>
    	<p>15.3.本服务条款任一条款被视为废止、无效或不可执行，该条款应视为可分的且不影响本服务条款及其他条款的有效性及可执行性。</p>
    	<p>15.4.智慧康有权在智慧康官网（www.hkzhihuikang.com）上发布公告、发站内通知或邮件通知等方式将本服务的权利义务全部或者部分转移给智慧康的关联公司。</p>
    	<p>15.5.除另有约定外，出于服务专业性考虑，智慧康亦可能委托关联公司或其他法律主体向您提供智慧康网站上一项或多项具体服务，同时您可能会与该等公司订立相关条款或条件，请您审慎阅读、充分理解条款和条件内容，选择接受或不接受该条款和条件。</p>
    	<p>15.6.本服务条款项下之保密条款、知识产权条款、法律适用与管辖条款以及性质上理应存续的其他条款（如对注册信息的真实性保证等），不因本条款的终止而失效。</p>
    	<p>15.7.智慧康将严格遵守自愿、平等、公平、诚信的合作原则，充分尊重合作方的自主经营权利。如发现智慧康员工存在违反上述合作原则的不当行为，可以通过智慧康监督邮箱【service@hkzhihuikang.com.com】反映问题，智慧康将遵循保密、客观的原则开展调查和处理。</p>`,
};
